import Grid from '@mui/material/Grid2';
import { FileDisplaySkeleton } from './FileDisplay/FileDisplaySkeleton';

type ListFilesSkeletonProps = {
  count?: number;
  location?: string;
  margin?: number;
};

export const ListFilesSkeleton = ({
  count = 3,
  location = '',
  margin = 1,
}: ListFilesSkeletonProps) => {
  return (
    <Grid container spacing={{ xl: 2, md: 1 }} py={margin} id={`${location}-attachments-skeleton`}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid size={{ lg: 4, sm: 6, xs: 12 }} key={`file-skeleton-${index}`}>
          <FileDisplaySkeleton location={location} />
        </Grid>
      ))}
    </Grid>
  );
};
